const TIER_COLOR =  {
    IRON: '#94868B',
    BRONZE: '#B97451',
    SILVER: '#A2C0C7',
    GOLD: '#F1A64D',
    PLATINUM: '#63B7B3',
    DIAMOND: '#738DF9',
    MASTER: '#9D5DDD',
    GRANDMASTER: '#EF4F4F',
    CHALLENGER: '#F4C873',
};

export default {
    bgColor: '#f5f5f5',
    whiteColor: '#ffffff',
    blackColor: '#000000',
    fontColor: '#e5ebef',
    mainTextColor: '#e5ebef',
    darkGreyColor: 'rgb(121, 134, 163)',
    lightGreyColor: 'rgb(229, 235, 239)',
    yellowColor: '#F3CC57',
    blueColor: '#49B4FF',
    borderRadius: '5px',
    tierColor: TIER_COLOR,
    rankColor : ["#11b288", "#207ac7", "#207ac7", "#207ac7", "#a0a0a0", "#a0a0a0", "#a0a0a0", "#a0a0a0"],
    traitsColor : ['#ca9372', '#92b1bd', '#ffb93b', '#ffb93b'],
    costColr: ["grey", "#11b288", "#207ac7", "#c440da", "#ffb93b"]
}